import { service } from '@ember/service';
import Route from '@ember/routing/route';
import type { ModelFrom } from 'tio-employee/types/route-model';
import type TasRoute from '../tas';
import type ReimaginedDataService from 'tio-employee/services/reimagined-data';

export default class AuthenticatedCareerPathwaysTasDashboardRoute extends Route {
  @service declare reimaginedData: ReimaginedDataService;

  async model() {
    const parentModel = this.modelFor('authenticated.reimagined.tas') as ModelFrom<TasRoute>;

    // Compute enrolled template IDs from the user's applications
    const enrolledTemplateIds = new Set(
      parentModel.tasData.applications
        .filter((app) => app.programTemplateId)
        .map((app) => app.programTemplateId as string)
    );

    const eligibleTemplates = await this.reimaginedData.fetchEligibleTemplates(enrolledTemplateIds);

    return {
      ...parentModel,
      eligibleTemplates,
    };
  }
}
